const PlusIcon =
    '<svg class="scale-75 md:scale-100 transition-all duration-200 ml-auto " width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="1" y1="-1" x2="35" y2="-1" transform="matrix(-1 0 0 1 36 18)" stroke="#00B67A" stroke-width="2" stroke-linecap="round"></line><line x1="1" y1="-1" x2="35" y2="-1" transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 17 36)" stroke="#00B67A" stroke-width="2" stroke-linecap="round"></line></svg>';

ckdc.ready(function ($) {
    const faqBlock = $('.ckdc-faq');
    if (faqBlock.length === 0) {
        return;
    }

    const faqItems = faqBlock.find('.ckdc-faq-item');
    if (faqItems.length === 0) {
        return;
    }

    faqItems.each((index, item) => {
        $(item).find('.ckdc-faq-item__answer_container').hide();
        $(item).find('.ckdc-faq-item__question').append(PlusIcon);

        $(item)
            .find('.ckdc-faq-item__question')
            .click(function (e) {
                e.preventDefault();
                $(item).toggleClass('ckdc-faq-item--active');
                $(item)
                    .find('.ckdc-faq-item__answer_container')
                    .slideToggle(100);
            });
    });
});
